import React, { FC } from 'react'
import { cn } from 'shared/utils'
import { useController } from 'react-hook-form'
import { Datepicker, InputGroup } from '@wmgtech/legato'

import { isRequired } from 'shared/utils/form'

import { FormDateProps } from './FormDate.props'
import './FormDate.scss'
import { localeFormat } from 'shared/utils/formatDate'

const FormDate: FC<FormDateProps> = ({
  control,
  fieldName,
  rules,
  dataTest,
  disabled,
  placeholder,
  className,
  label = '',
  autoComplete = 'off',
  ...dataPickerProps
}) => {
  const {
    field: { ref, ...restField },
    fieldState: { error }
  } = useController({
    name: fieldName,
    control,
    rules
  })

  return (
    <InputGroup
      className={cn('form-input-group', className)}
      label={label}
      labelProps={{ icon: isRequired(rules) && label ? 'asterisk' : undefined }}
      validation={{
        message: error?.message,
        ...(error && { type: 'error' })
      }}
    >
      <Datepicker
        {...dataPickerProps}
        dateFormat={localeFormat()}
        className="form-date"
        disabled={disabled}
        data-test={dataTest}
        placeholder={placeholder}
        {...restField}
        onChange={(date: Date) => restField.onChange(date)}
        selected={restField.value}
        autoComplete={autoComplete}
      />
    </InputGroup>
  )
}

export default FormDate
